import styled, { css } from 'styled-components'

export const CatalogItemTagLayoutStyled = styled.div<{
  $isWarning: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: ${(props) => props.theme.space.xsmall};
  padding: ${(props) =>
    `${props.theme.typography.pxToRem(4)} ${props.theme.space.small}`};
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};

  ${(props) =>
    props.$isWarning
      ? css`
          width: 100%;
          background: ${props.theme.colors.alert.warning.background};
        `
      : css`
          border: ${props.theme.typography.pxToRem(1)} solid
            ${props.theme.colors.content.border};
          background: ${props.theme.colors.content.contentBackground};
        `}
`
